module.exports = __webpack_public_path__ + "img/奖品-watch.c739ab5b.png";